module.exports = __webpack_public_path__ + "static/img/swiper_title.78da1fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/swiper_title.png
// module id = gvTc
// module chunks = 0